<template>
  <div>
    <DefaultPage id="financials">
      <div class="financials">
        <div class="hero">
          <HeroTexture class="hero-texture" />
          <HeroTextureTwo class="hero-texture-two" />
          <div class="hero-flex-wrap">
            <div class="grid-x grid-margin-x align-middle">
              <div class="cell large-9 xlarge-7 xxlarge-6">
                <div class="hero__call">
                  <h1
                    class="hero__headline"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                  >
                    Financials
                  </h1>
                  <div
                    class="hero__call__content"
                    data-aos="fade-left"
                    data-aos-duration="1000"
                  >
                    <p>
                      Our solid financial standing gives our policyholders the assurance that SVMIC will be here to support and protect them when needed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ContentSection
          id="highlights"
          title="Financial Highlights"
          class="financial-section"
        >
          <div class="grid-x">
            <div class="cell" data-aos="fade-up">
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                    <tr>
                      <th><h4>At Year End</h4>
                        <p>($ in thousands)</p></th>
                      <th><h4>2020</h4></th>
                      <th><h4>2021</h4></th>
                      <th><h4>2022</h4></th>
                      <th><h4>2023</h4></th>
                      <th><h4>2024</h4></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Cash and Invested Assets</td>
                      <td class="number">1,294,540</td>
                      <td class="number">1,390,803</td>
                      <td class="number">1,357,781</td>
                      <td class="number">1,442,715</td>
                      <td class="number">1,507,589</td>
                    </tr>
                    <tr>
                      <td>Total Assets</td>
                      <td class="number">1,321,878</td>
                      <td class="number">1,415,225</td>
                      <td class="number">1,385,631</td>
                      <td class="number">1,473,577</td>
                      <td class="number">1,539,615</td>
                    </tr>
                    <tr>
                      <td>Loss &amp; Loss Adjustment Expense Reserves</td>
                      <td class="number">456,000</td>
                      <td class="number">468,500</td>
                      <td class="number">461,000</td>
                      <td class="number">488,000</td>
                      <td class="number">508,000</td>
                    </tr>
                    <tr>
                      <td>Policyholders’ Surplus</td>
                      <td class="number">705,694</td>
                      <td class="number">778,138</td>
                      <td class="number">766,831</td>
                      <td class="number">821,076</td>
                      <td class="number">860,192</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="separate-tables"><!--x--></div>
              <div class="table-scroll">
                <table class="align-table-1">
                  <thead>
                    <tr>
                      <th><h4>For The Year</h4>
                        <p>($ in thousands)</p></th>
                      <th><h4>2020</h4></th>
                      <th><h4>2021</h4></th>
                      <th><h4>2022</h4></th>
                      <th><h4>2023</h4></th>
                      <th><h4>2024</h4></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Gross Written Premium</td>
                      <td class="number">113,815</td>
                      <td class="number">121,824</td>
                      <td class="number">137,233</td>
                      <td class="number">145,691</td>
                      <td class="number">153,490</td>
                    </tr>
                    <tr>
                      <td>Net Investment Income</td>
                      <td class="number">28,148</td>
                      <td class="number">26,398</td>
                      <td class="number">35,345</td>
                      <td class="number">35,550</td>
                      <td class="number">45,402</td>
                    </tr>
                    <tr>
                      <td>Net Paid Loss &amp; Loss Adjustment Expenses</td>
                      <td class="number">80,225</td>
                      <td class="number">72,699</td>
                      <td class="number">91,332</td>
                      <td class="number">80,594</td>
                      <td class="number">92,658</td>
                    </tr>
                    <tr>
                      <td>Policyholders’ Dividends Declared</td>
                      <td class="number">7,000</td>
                      <td class="number">7,000</td>
                      <td class="number">7,500</td>
                      <td class="number">8,500</td>
                      <td class="number">9,000</td>
                    </tr>
                    <tr>
                      <td>Net Income</td>
                      <td class="number">23,853</td>
                      <td class="number">17,077</td>
                      <td class="number">21,669</td>
                      <td class="number">16,288</td>
                      <td class="number">14,000</td>
                    </tr>
                    <tr class="spacer-row"></tr>
                    <tr>
                      <td>Cumulative Dividends and Return of Capital</td>
                      <td class="number">377,500</td>
                      <td class="number">384,500</td>
                      <td class="number">392,000</td>
                      <td class="number">400,500</td>
                      <td class="number">409,500</td>
                    </tr>
                    <tr>
                      <td>Cumulative Mutual Value Plan Allocations</td>
                      <td class="number">97,918</td>
                      <td class="number">110,888</td>
                      <td class="number">122,475</td>
                      <td class="number">134,760</td>
                      <td class="number">147,790</td>
                    </tr>
                    <tr>
                      <td>Outstanding Mutual Value Plan Balances</td>
                      <td class="number">87,463</td>
                      <td class="number">94,382</td>
                      <td class="number">98,304</td>
                      <td class="number">103,021</td>
                      <td class="number">108,569</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ContentSection>
        <ContentSection id="mvp-allocations">
          <template v-slot:header>
            <h3>Mutual Value Plan<span class="registered">&reg;</span> Allocations</h3>
          </template>
          <ChartContainer aosId="mvp-allocations-chart">
            <MvpAllocationsChart/>
          </ChartContainer>
          <p class="note chart-note">Established in 2018</p>
        </ContentSection>
        <ContentSection id="mvp-distributions">
          <template v-slot:header>
            <h3>Cumulative Mutual Value Plan<span class="registered">&reg;</span> Distributions</h3>
          </template>
          <ChartContainer aosId="mvp-distributions-chart">
            <MvpDistributionsChart/>
          </ChartContainer>
          <p class="note chart-note">Established in 2018</p>
        </ContentSection>
        <ContentSection
          id="policyholders-surplus"
          title="Policyholders' Surplus &amp; Total Assets"
          class="financial-section"
        >
          <div
            class="chart-label-container"
            data-aos="fade-down"
          >
            <div class="grid-x">
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label2">
                  </div>
                  <p>Policyholders’ Surplus</p>
                </div>
              </div>
              <div class="large-3 small-6">
                <div class="chart-label">
                  <div class="dot label1">
                  </div>
                  <p>Total Assets</p>
                </div>
              </div>
            </div>
          </div>
          <ChartContainer aosId="policyholders-surplus-chart">
            <PolicyholdersSurplusChart />
          </ChartContainer>
        </ContentSection>
        <ContentSection
          id="cumulative-dividends"
          title="Cumulative Dividends Declared &amp; Return of Capital"
        >
          <ChartContainer aosId="cumulative-dividends-chart">
            <CumulativeDividendsChart/>
          </ChartContainer>
        </ContentSection>
        <TheSubFooter next-route="/leadership" />
      </div>
    </DefaultPage>
  </div>
</template>

<script>
import DefaultPage from '@/layouts/DefaultPage';
import TheSubFooter from '@/components/footer/TheSubFooter';
import ContentSection from '@/components/section/VisualDataSection';
import MvpAllocationsChart from '@/components/chart/MvpAllocationsChart';
import MvpDistributionsChart from '@/components/chart/MvpDistributionsChart';
import PolicyholdersSurplusChart from '@/components/chart/PolicyholdersSurplusChart';
import ChartContainer from '@/components/chart/ChartContainer';
import CumulativeDividendsChart from '@/components/chart/CumulativeDividendsChart';
import HeroTexture from '@/assets/texture-financials-hero.svg';
import HeroTextureTwo from '@/assets/texture-financials-hero-2.svg';

export default {
  name: 'Financials',
  components: {
    MvpAllocationsChart,
    MvpDistributionsChart,
    CumulativeDividendsChart,
    ChartContainer,
    PolicyholdersSurplusChart,
    ContentSection,
    TheSubFooter,
    DefaultPage,
    HeroTexture,
    HeroTextureTwo,
  },
  data () {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/setup/variables.scss';
#mvp-allocations {
  .cell:first-of-type {
    margin-bottom: 4rem;
    @include breakpoint(large) {
      margin-bottom: 0;
    }
  }
}
</style>
